<template>
  <div class="home">
    <AccessProcess title="Access process" />
       
  </div>
</template>

<script>
import AccessProcess from "@/components/AccessProcess.vue";
//import shared from "@/shared";

export default {
  name: "AccessView",
  components: {
    AccessProcess,
  },
};
</script>